import React, { useState } from 'react';
import { FaUser, FaEnvelope, FaLock } from 'react-icons/fa';
import TextInputWithIcon from '../../components/TextInput/TextInput';
import Button from '../../components/Button/Button';
import buttonStyles from '../../components/Button/Button.module.css';
import styles from './Signup.module.css';
import {useNavigate} from 'react-router-dom';

const Signup = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    confirmPassword: ''
  });

  const handleChange = (e) => {
    setFormData({ 
      ...formData, 
      [e.target.name]: e.target.value 
    });
  };


  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if(formData.password != formData.confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      setError('Invalid Email');
      return;
    }

    try {
      const response = await fetch('https://377storage.vip/api/signup', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
        name: formData.name,
        email: formData.email,
        password: formData.password,
      }),
    });

      const data = await response.json();

      if (response.ok) {
        navigate('/account-created');
        setError('');
      } else {
        setError(data.detail || 'Signup failed');
      }
    } catch (err) {
      console.error(err);
      setError('Server error. Please try again later.')
    }
  };

return (
  <div style={{ position: 'relative', height: '100vh', overflow: 'hidden' }}>
    {/* Blurred background image layer */}
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundImage: "url('/images/iStock-907888472.jpg')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        filter: 'blur(6px)',
        zIndex: 1,
      }}
    />
    
    {/* Foreground content (signup form) */}
    <div className={styles.formContainer} style={{ position: 'relative', zIndex: 2 }}>
      <h1 className={styles.title}>Register</h1>
      <form onSubmit={handleSubmit}>
        <TextInputWithIcon
          icon={<FaUser />}
          className={styles.entry}
          placeholder="Name"
          name="name"
          value={formData.name}
          onChange={handleChange}
        />
        <TextInputWithIcon
          icon={<FaEnvelope />}
          className={styles.entry}
          placeholder="Email"
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
        />
        <TextInputWithIcon
          icon={<FaLock />}
          placeholder="Password"
          type="password"
          name="password"
          value={formData.password}
          onChange={handleChange}
        />
        <TextInputWithIcon
          icon={<FaLock />}
          placeholder="Confirm Password"
          type="password"
          name="confirmPassword"
          value={formData.confirmPassword}
          onChange={handleChange}
        />
        {error && <div className={styles.error}>{error}</div>}
        <Button type="submit" className={buttonStyles.signup}>Register</Button>
      </form>
    </div>
  </div>
);

};

export default Signup;
